module.exports = __webpack_public_path__ + "static/media/VIDT-BNB.e920c27f.svg";